import { StrictMode, useEffect } from 'react'
import { createRoot } from 'react-dom/client'
import { RouterProvider, createRouter } from '@tanstack/react-router'
import { QueryClient, QueryClientProvider, hydrate } from '@tanstack/react-query'

// Import the generated route tree
import { routeTree } from './routeTree.gen'

import './index.css'
import { logVisit } from './lib/analytics'

// Create a new router instance
const router = createRouter({ routeTree, defaultPreload: 'intent' })

// Register the router instance for type safety
declare module '@tanstack/react-router' {
  interface Register {
    router: typeof router
  }
}

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 1000 * 60 * 5,
      refetchOnWindowFocus: false,
    },
  },
})

const queryState = document.head.querySelector('script[data-query-state]')
if (queryState?.textContent) {
  try {
    hydrate(queryClient, JSON.parse(queryState.textContent))
  } catch {}
  queryState.remove()
}

function App() {
  useEffect(() => {
    logVisit()
  }, [])

  return (
    <QueryClientProvider client={queryClient}>
      <RouterProvider router={router} />
    </QueryClientProvider>
  )
}

document.head.querySelectorAll('[data-prerender-head]').forEach((element) => element.remove())
const root = createRoot(document.getElementById('root')!)
root.render(
  <StrictMode>
    <App />
  </StrictMode>
)
